import React from 'react';

import ErrorMessage from 'components/vistaprintUILibrary/ErrorMessage';
import { colors } from 'settings/theme';

export default function TextField(props) {
    const {
        value, // required
        onChange, // required
        children,
        label = undefined,
        fullWidth = false,
        id = undefined, // required if label is provided (to link label and input)
        errorMessage = null,
        required = false, // adds an asterisk to the label
        disabled = false,
        labelStyle = {},
        style = {},
        ...restProps, // additional props will be added to the input element
    } = props;

    if (label && !id) {
        throw new Error('"id" property is required if "label" is provided. "id" is needed to link the label and input elements');
    }

    // ui library doesn't seem to have a class to add for errors on a textarea (the input-skin-error class only works on input elements)
    let errorStyle = {};
    if (errorMessage !== null) {
        errorStyle = {
            borderColor: colors.danger,
            boxShadow: `inset 0 0 0 1px ${colors.danger}`,
        };
    }

    return (
        <div style={{display:"inline-block"}}>
            {label &&
                <label
                    className="above"
                    htmlFor={id}
                    style={labelStyle}
                >
                    {`${label}${required ? '*' : ''}`}
                </label>
            }

            <div className="stylized-select-container">
                <select
                    id={id}
                    className="stylized-select"
                    disabled={disabled}
                    value={value}
                    onChange={onChange}
                    style={{
                        width: fullWidth ? '100%' : undefined,
                        ...style,
                        ...errorStyle,
                    }}
                    {...restProps}
                >
                    {children}
                </select>
            </div>
                {errorMessage && <ErrorMessage containerStyle={{ marginTop: 3 }} text={errorMessage} /> }
            </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/vistaprintUILibrary/Dropdown.js